/* Redivio scroll-reveal (W2R fix): adds .redivio-in to .redivio-reveal elements as they
   enter the viewport. The hidden state in redivio-commerce.css is gated on html.js AND
   prefers-reduced-motion, so with no JS (or reduced motion) content simply shows.
   If IntersectionObserver is unavailable, reveal everything immediately. */
(function () {
  var els = document.querySelectorAll('.redivio-reveal');
  if (!els.length) return;
  var show = function (el) { el.classList.add('redivio-in'); };
  if (!('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(show);
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        show(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  els.forEach(function (el) { observer.observe(el); });
})();
